import i18next from 'i18next';

i18next.addResources('es_CL', 'CartDetails', {
  product: 'Producto:',
  products: 'Productos:'
});
